import { useT } from "../lang/LangContext";

export function Footer() {
  const t = useT();

  return (
    <footer
      style={{
        borderTop: "3px solid var(--fg)",
        padding: "22px 20px",
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: 12,
        letterSpacing: "0.1em",
      }}
    >
      <span>© 2026 RODRIGO FERREIRA · UBERLÂNDIA, BR</span>
      <span style={{ opacity: 0.6 }}>
        {t(
          "HANDMADE. NO TEMPLATE. ↑↑↓↓←→←→BA",
          "FEITO À MÃO. SEM TEMPLATE. ↑↑↓↓←→←→BA"
        )}
      </span>
    </footer>
  );
}
